import { GET_CONFIGURATION_OKTA } from '../../constants/api';

const oktaApi = `${GET_CONFIGURATION_OKTA}`;

export { oktaApi };
